const LOGIN_TRACKING_EVENTS = {
  login_page_email_interacted: 'login_page_email_interacted',
  login_page_password_interacted: 'login_page_password_interacted',
  login_page_forget_password_clicked: 'login_page_forget_password_clicked',
  login_page_forget_password_email_interacted:
    'login_page_forget_password_email_interacted',
  login_page_send_password_reset_link_click:
    'login_page_send_password_reset_link_click',
  login_page_send_password_reset_link_successful:
    'login_page_send_password_reset_link_successful',
  login_page_send_password_reset_link_failed:
    'login_page_send_password_reset_link_failed',
  login_page_login_click: 'login_page_login_click',
  login_page_post_login_otp_pop_up_appears:
    'login_page_post_login_otp_pop_up_appears',
  login_page_post_login_otp_pop_up_otp_interacted:
    'login_page_post_login_otp_pop_up_otp_interacted',
  login_page_post_login_otp_pop_up_login_and_confirm_clicked:
    'login_page_post_login_otp_pop_up_login_and_confirm_clicked',
  login_successful: 'login_successful',
  login_failed: 'login_failed',
  login_page_sign_in_with_google_clicked:
    'login_page_sign_in_with_google_clicked',
}

export const DEALS_TRACKING_EVENTS = {
  deals_campaign_create_start: 'deals_campaign_create_start',
  deals_campaign_create_progress: 'deals_campaign_create_progress',
  deals_campaign_create_complete: 'deals_campaign_create_complete',
  deals_campaign_edit_start: 'deals_campaign_edit_start',
  deals_campaign_edit_complete: 'deals_campaign_edit_complete',
  deals_advertiser_created: 'deals_advertiser_created',
}

const NAVIGATION_BAR_EVENTS = {
  global_navbar_dashboard_clicked: 'global_navbar_dashboard_clicked',
  global_navbar_orders_clicked: 'global_navbar_orders_clicked',
  global_navbar_disputes_clicked: 'global_navbar_disputes_clicked',
  global_navbar_settlement_clicked: 'global_navbar_settlement_clicked',
  global_navbar_invoices_clicked: 'global_navbar_invoices_clicked',
  global_navbar_transactions_clicked: 'global_navbar_transactions_clicked',
  global_navbar_billing_clicked: 'global_navbar_billing_clicked',
  global_navbar_business_address_clicked:
    'global_navbar_business_address_clicked',
  global_navbar_exported_requests_clicked:
    'global_navbar_exported_requests_clicked',
  global_navbar_contact_information_clicked:
    'global_navbar_contact_information_clicked',
  global_navbar_webhooks_clicked: 'global_navbar_webhooks_clicked',
  global_navbar_instore_settings_clicked:
    'global_navbar_instore_settings_clicked',
  global_navbar_instore_barcode_clicked:
    'global_navbar_instore_barcode_clicked',
  global_navbar_manage_branches_clicked:
    'global_navbar_manage_branches_clicked',
  global_navbar_instore_material_clicked:
    'global_navbar_instore_material_clicked',
  global_navbar_api_tokens_clicked: 'global_navbar_api_tokens_clicked',
  global_navbar_users_clicked: 'global_navbar_users_clicked',
  global_navbar_manage_users_clicked: 'global_navbar_manage_users_clicked',
  global_navbar_manage_roles_clicked: 'global_navbar_manage_roles_clicked',
  global_navbar_documenation_clicked: 'global_navbar_documenation_clicked',
  global_navbar_partner_marketing_kit_clicked:
    'global_navbar_partner_marketing_kit_clicked',
  global_navbar_accounts_header_clicked:
    'global_navbar_accounts_header_clicked',
}

const PAGE_VIEW_EVENTS = {
  login_page_viewed: 'login_page_viewed',
  dashboard_viewed: 'dashboard_viewed',
  order_list_viewed: 'orders_listing_viewed',
  dispute_list_viewed: 'disputes_listing_viewed',
  settlement_list_viewed: 'settlements_viewed',
  invoice_list_viewed: 'invoices_viewed',
  transaction_list_viewed: 'transactions_viewed',
  instore_material_page_viewed: 'instore_material_page_viewed',
  deals_page_view: 'deals_page_view',
}

const EVENT_TRACKING_MAP = {
  page_view: PAGE_VIEW_EVENTS,
  ...LOGIN_TRACKING_EVENTS,
  ...DEALS_TRACKING_EVENTS,
  ...NAVIGATION_BAR_EVENTS,
}

export default EVENT_TRACKING_MAP
